import { Observable } from 'rxjs/Observable';
import history from '../routers/history';
import getEventSongs from '../actions/events/getEventSongsAction';
import setBranchHostPermission from '../actions/events/setBranchHostPermissionAction';

export function handleGetEventInfoFulfilled(action$, store) {
   return action$.filter(
      action => action.type === 'GET_EVENT_INFO_FULFILLED')
      .mergeMap(() => {
         let merged = Observable.merge(
             Observable.of(() => history.push('/events/currentEventDetails')),
            Observable.of(getEventSongs(store.getState().events.currentEvent.objectId)));
         if (store.getState().events.currentEvent.hostDeepLink) {
            return merged;
         } else {
            return merged.merge(Observable.of(setBranchHostPermission(store.getState().events.currentEvent.objectId)));
         }
      });
}



// WEBPACK FOOTER //
// ./src/epics/getEventInfoEpic.js